import { render, staticRenderFns } from "./allacciatura-fits.vue?vue&type=template&id=9e05a328&scoped=true&"
import script from "./allacciatura-fits.vue?vue&type=script&lang=js&"
export * from "./allacciatura-fits.vue?vue&type=script&lang=js&"
import style0 from "./allacciatura-fits.vue?vue&type=style&index=0&id=9e05a328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e05a328",
  null
  
)

export default component.exports